import React from 'react';
import styled from 'styled-components';
import { LayoutContext } from 'contexts';
import { PickerTimeProps } from 'antd/es/date-picker/generatePicker';

import { AntdDatePicker } from '../DatePicker';

import LabelWrapper from '../LabelWrapper';
import theme from '../theme';

// As per antd documentation https://ant.design/docs/react/replace-moment
// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface AntdTimePickerProps extends Omit<PickerTimeProps<Date>, 'picker'> {}
const AntdTimePicker = React.forwardRef<any, AntdTimePickerProps>(
  (props, ref) => (
      <AntdDatePicker {...props} picker="time" mode={undefined} ref={ref} />
    ),
);

export type TimePickerProps = AntdTimePickerProps & {
  label?: string;
  error?: string | boolean;
  required?: boolean;
};

export const TimePicker: React.FC<TimePickerProps> = ({
  label,
  required,
  getPopupContainer,
  allowClear = false, // For consistency with other components
  error,
  className,
  ...props
}) => {
  const layout = React.useContext(LayoutContext);

  const getContainerFunction = () => {
    if (getPopupContainer) return getPopupContainer;
    if (layout?.scrollContainer) return () => layout.scrollContainer;
    return null;
  };

  return (
    <LabelWrapper
      label={label}
      error={error}
      required={required}
      className={className}
    >
      <StyledTimePicker
        {...props}
        getPopupContainer={getContainerFunction()}
        allowClear={allowClear}
      />
    </LabelWrapper>
  );
};

const StyledTimePicker = styled(AntdTimePicker)`
  background-color: ${theme.gray3};
`;

export default styled(TimePicker)``;
